<template>
  <div>
    <div class="challenge-wrapper">
      <div class="legend-container">
        <span class="legend-label">Below halfway </span>
        <span>
          <alert
            :width="32"
            :height="32"
            :color="'#FF0000'"
            :stroke="1.5"
          ></alert>
        </span>
        <span class="legend-label"> Halfway </span>
        <span>
          <checkmark
            :width="32"
            :height="32"
            :color="'#ffff00'"
            :stroke="1.5"
          ></checkmark>
        </span>
        <span class="legend-label">Done</span>
        <span>
          <checkmark
            :width="32"
            :height="32"
            :color="'#00b341'"
            :stroke="1.5"
          ></checkmark>
        </span>
        <span class="legend-label">x2</span>
        <span>
          <star
            :width="32"
            :height="32"
            :color="'#ffff00'"
            :stroke="1.5"
          ></star>
        </span>
      </div>
    </div>

    <loading-spinner class="center" v-if="this.loading"></loading-spinner>

    <div class="list" v-if="data">
      <div class="l-item" v-for="user in leaderData" :key="user.id">
        <img class="pic" :src="user.image" />
        <div class="name">
          {{ user.firstname }}
        </div>
        <div
          v-for="(week, idx) in weeks"
          class="score"
          :key="week"
          @click="setUserWeek(user, week)"
        >
          <span v-bind:class="{ selected: user.selectedWeek == week }">
            W{{ week }}
          </span>
          <span v-if="user.weeks[idx] > 25200">
            <star
              :width="32"
              :height="32"
              :color="'#FFFF00'"
              :stroke="1.5"
            ></star>
          </span>
          <span v-if="user.weeks[idx] > 12600 && user.weeks[idx] < 25200">
            <checkmark
              :width="32"
              :height="32"
              :color="'#00b341'"
              :stroke="1.5"
            ></checkmark>
          </span>
          <span v-if="user.weeks[idx] > 6300 && user.weeks[idx] < 12600">
            <checkmark
              :width="32"
              :height="32"
              :color="'#ffff00'"
              :stroke="1.5"
            ></checkmark>
          </span>
          <span v-if="user.weeks[idx] <= 6300">
            <alert
              :width="32"
              :height="32"
              :color="'#FF0000'"
              :stroke="1.5"
            ></alert>
          </span>
        </div>
        <div class="total">
          <span>
            {{ getWeeklyMinutes(user.id, user.selectedWeek) }}
          </span>
          <br>
          <span>
            {{ user.totalTime }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Checkmark from "@/components/Icons/Checkmark";
import Alert from "@/components/Icons/Alert";
import LoadingSpinner from "@/components/LoadingSpinner";
import Star from "@/components/Icons/Star";

const humanizeDuration = require("humanize-duration");
const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");
var _ = require("lodash");
import moment from "moment";

export default {
  name: "ChallengeAll",
  components: {
    Checkmark,
    LoadingSpinner,
    Alert,
    Star,
  },
  data() {
    return {
      data: [],
      weeks: this.getWeeks(),
      loading: true,
    };
  },
  created() {
    this.getLeaderboard().then((result) => {
      this.data = result;
      this.data.forEach((user) => {
        user.selectedWeek = moment(new Date()).isoWeek();
        user.totalTime = shortEnglishHumanizer(
          _.sumBy(user.activities, "moving_time") * 1000,
          {
            units: ["h"],
            round: true,
          }
        );
      });
      this.loading = false;
    });
  },
  computed: {
    leaderData() {
      let dat = this.data;
      dat.forEach((user) => {
        user.weeks = [];

        for (let w in this.weeks) {
          let weeklyData = user.activities.filter(
            (act) => act.week == this.weeks[w]
          );

          user.weeks.push(_.sumBy(weeklyData, "moving_time"));
        }
        user.test = "tesdt";
      });

      return dat;
    },
  },
  methods: {
    async getLeaderboard() {
      try {
        const { data } = await UserRepository.getLeaderboardAll();
        return data;
      } catch (err) {
        console.log(err);
      }
    },
    getWeeklyMinutes(userId, weekNumber) {
      let data = JSON.parse(JSON.stringify(this.data));

      let userActivities = data.filter((act) => act.id == userId);
      let weekly = userActivities[0].activities.filter(
        (act) => act.week == weekNumber
      );

      let weekSum = _.sumBy(weekly, "moving_time");
      let timeHuman = shortEnglishHumanizer(weekSum * 1000, {
        units: ["h", "m"],
        round: true,
      });

      return timeHuman;
    },
    getWeeks() {
      let startDate = moment()
        .startOf("year")
        .endOf("week")
        .format("YYYY-MM-DD");
      let endDate = moment(new Date()).endOf("week").format("YYYY-MM-DD");

      const weeks = [];
      while (startDate <= endDate) {
        weeks.push(moment(startDate).isoWeek());
        startDate = moment(startDate).add(7, "days").format("YYYY-MM-DD");
      }

      return weeks;
    },
    setUserWeek(user, week) {
      user.test = Math.random(0, 10);
      user.selectedWeek = week;
    },
  },
};
</script>
  
  <style scoped>
.selected {
  color: #ffffff;
  font-weight: 900;
  text-shadow: 0 0 3px #ffffff;
}

.center {
  margin: auto;
}

.info-text {
  /* font-size: 22px; */
  font-size: 1rem;
}

.legend-container {
  border-radius: 4rem;
  max-width: 500px;
  display: flex;
  text-align: center;
  justify-content: center;
  line-height: 30px;
  flex-direction: row;
  margin: 0px 10px;
  color: #cedbed;
  background: #17283f;
  padding: 1em;
}

.legend-label {
  margin-left: 5px;
}

.challenge-wrapper {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.list {
  padding: 3em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.list .l-item {
  max-width: 1500px;
  width: 750px;
  position: relative;
  display: flex;
  align-items: center;
  color: #cedbed;
  border-radius: 4rem;
  margin-bottom: 2rem;
  background: #17283f;
  transform-origin: left;
  cursor: pointer;
  transition: transform 200ms ease-in-out;
  box-shadow: 0 0 4rem 0 rgba(0, 0, 0, 0.1),
    0 1rem 2rem -1rem rgba(0, 0, 0, 0.3);
}

@media only screen and (max-width: 768px) {
  .list .l-item {
    width: 90vw;
    position: relative;
    display: flex;
    align-items: center;
    color: #cedbed;
    border-radius: 4rem;
    margin-bottom: 2rem;
    background: #17283f;
    transform-origin: left;
    cursor: pointer;
    transition: transform 200ms ease-in-out;
    box-shadow: 0 0 4rem 0 rgba(0, 0, 0, 0.1),
      0 1rem 2rem -1rem rgba(0, 0, 0, 0.3);
  }
}

.list .l-item .pos {
  font-weight: 900;
  position: absolute;
  left: -2rem;
  text-align: center;
  font-size: 1.25rem;
  width: 1.5rem;
  color: #cedbed;
  opacity: 0.6;
  transition: opacity 200ms ease-in-out;
}
.list .l-item .pic {
  max-width: 4rem;
  max-height: 4rem;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  margin-right: 1rem;
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2),
    0 1rem 1rem -0.5rem rgba(0, 0, 0, 0.3);
}
.list .l-item .name {
  flex-grow: 2;
  flex-basis: 5rem;
  font-size: 1.1rem;
}
.list .l-item .total {
  flex-grow: 2;
  flex-basis: 5rem;
  font-size: 0.9rem;
}
.list .l-item .score {
  margin-right: 10px;
  opacity: 0.7;
}
.list .l-item .score:last-of-type {
  margin-right: 0px;
}

.list .l-item .flash-percent {
  margin-right: 1.5rem;
  opacity: 0.7;
}
.list .l-item .flash-percent:after {
  margin-right: 0.7rem;
  content: "flash";
  opacity: 0.7;
}
.list .l-item .sessions {
  margin-right: 1.5rem;
  opacity: 0.5;
}
.list .l-item .sessions:after {
  margin-right: 1rem;
  content: "sessions";
  opacity: 0.5;
}
.list .l-item:hover .pos {
  opacity: 0.8;
}
</style>